import PropTypes from 'prop-types';

// form
import { useFormContext, Controller } from 'react-hook-form';


import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TextField, Box } from '@mui/material';
// ----------------------------------------------------------------------
RHFDatePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disableFuture: PropTypes.bool,
  isRequired: PropTypes.bool,
  onKeyUp: PropTypes.func,
  onChange: PropTypes.func,

};

export default function RHFDatePicker({ name, disableFuture = false, onKeyUp = null, onChange = null, ...others }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => <LocalizationProvider
        dateAdapter={AdapterDayjs}
        error
      >
        <Box sx={{ display: 'grid', gridTemplateRows: 'repeat(1, 1fr)' }}>

          <DatePicker
            disableFuture={disableFuture}
            inputFormat="DD/MM/YYYY"
            value={field.value}

            onChange={(date) => {
              if (date !== null) {
                field.onChange(new Date(date));
                if (onChange) onChange();
              }
              else
                field.onChange(null);

            }}


            renderInput={(params) => <TextField id={others.id}
              {...params}
              onKeyUp={onKeyUp}
              error={!!error} helperText={error?.message} />}
            {...others}
          />
        </Box>
      </LocalizationProvider >

      }
    />
  );
}
